import { computed, Signal } from '@angular/core';
import { AngularNodeViewComponent } from 'ngx-tiptap';

/**
 * Abstract base class for Tiptap node view components that provides typed access to node attributes.
 *
 * @template T - The interface type representing the node's attributes
 */
export abstract class NodeViewComponent<T extends object> extends AngularNodeViewComponent {
  abstract getDefaults(): T;

  /**
   * Typed computed signal that returns the node's attributes.
   * Provides type-safe access to node attributes.
   */
  readonly props = computed(() => {
    return this.node().attrs as T;
  });

  getProp<U extends keyof T>(key: U): Signal<T[U]> {
    return computed(() => {
      const props = this.props();
      const value = props[key];

      if (value === undefined) {
        return this.getDefaults()[key];
      }
      return value;
    });
  }

  updateProps(attrs: Partial<T>): void {
    this.updateAttributes()(attrs);
  }

  updateProp<U extends keyof T>(key: U, value: T[U]): void {
    this.updateAttributes()({ [key]: value });
  }
}
